var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0752 15.0376C30.0752 6.73684 23.3383 0 15.0376 0C6.73684 0 0 6.73684 0 15.0376C0 22.3158 5.17293 28.3759 12.0301 29.7744V19.5489H9.02256V15.0376H12.0301V11.2782C12.0301 8.37594 14.391 6.01504 17.2932 6.01504H21.0526V10.5263H18.0451C17.218 10.5263 16.5414 11.203 16.5414 12.0301V15.0376H21.0526V19.5489H16.5414V30C24.1353 29.2481 30.0752 22.8421 30.0752 15.0376Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e51d4bcc9987a33ccb5de8fd63e73c45.svg";
export { ForwardRef as ReactComponent };